import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    token: '',
    userInfo: {
      loginName: '',
      userTel: ''
    },
    userMsg: {},
    menu: {},
    viewData: null,
    blockPoints: null
  },

  page: {
    employee: {
      userId: null,
      userUuid: null,
    }
  },

  mutations: {
    addUserTel(state, userTel) {
      state.userInfo.userTel = userTel
      window.localStorage.setItem('userTel', userTel)
    },
    addToken(state, token) {
      state.token = token
      window.localStorage.setItem('accessToken', token)
    },
    addMenu(state, menu) {
      state.menu = menu
      window.localStorage.setItem('menu', menu)
    },
    addUserInfo(state, userInfo) {
      state.userInfo = userInfo
      window.localStorage.setItem('userInfo', userInfo)
    },
    // 保存用户全部信息
    addUserMsg(state, userMsg) {
      state.userMsg = userMsg
      window.localStorage.setItem('userMsg', userMsg)
    },
    addViewData(state, viewData) {
      state.viewData = viewData
      window.localStorage.setItem('viewData', JSON.stringify(viewData))
    },
    addBlockPoints(state, blockPoints) {
      state.blockPoints = blockPoints
      window.localStorage.setItem('blockPoints', JSON.stringify(blockPoints))
    }

  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js